import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaBars,
  FaMoon,
  FaSun,
  FaUser,
  FaCog,
  FaSignOutAlt,
} from "react-icons/fa";
import { useTheme } from "../../contexts/ThemeContext";
import { useAuth } from "../../contexts/AuthContext";
import NotificationCenter from "../../notifications/NotificationCenter";

const AdminNavbar = ({ toggleSidebar }) => {
  const { darkMode, toggleDarkMode } = useTheme();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const toggleUserMenu = () => setShowUserMenu(!showUserMenu);

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      console.error("Erreur lors de la déconnexion:", error);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white dark:bg-slate-800 border-b border-gray-200 dark:border-slate-700 shadow-md z-30 px-4 py-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <button
            onClick={toggleSidebar}
            className="p-2 mr-3 rounded-md text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700"
            aria-label="Menu"
          >
            <FaBars size={20} />
          </button>
          <Link to="/admin" className="flex items-center">
            <span className="text-xl font-bold text-indigo-600 dark:text-indigo-400">
              Baobab Exchange Admin
            </span>
          </Link>
        </div>

        <div className="flex items-center space-x-3">
          {/* Bouton thème */}
          <button
            onClick={toggleDarkMode}
            className="p-2 rounded-full text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700"
            title={darkMode ? "Mode clair" : "Mode sombre"}
          >
            {darkMode ? <FaSun size={18} /> : <FaMoon size={18} />}
          </button>

          {/* VRAI Centre de Notifications */}
          <NotificationCenter />

          {/* User Menu */}
          <div className="relative ml-3">
            <button
              onClick={toggleUserMenu}
              className="flex items-center text-sm focus:outline-none"
            >
              <div className="h-8 w-8 rounded-full bg-indigo-100 dark:bg-indigo-900 flex items-center justify-center text-indigo-600 dark:text-indigo-300">
                <FaUser size={16} />
              </div>
              <span className="ml-2 text-gray-700 dark:text-gray-300 hidden md:block">
                {user?.name || user?.email || "Admin"}
              </span>
            </button>

            {showUserMenu && (
              <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-slate-800 rounded-md shadow-lg py-1 z-50 border border-gray-200 dark:border-slate-700">
                <Link
                  to="/admin/profile"
                  className="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700"
                >
                  <FaUser className="inline mr-2" size={14} />
                  Profil
                </Link>
                <Link
                  to="/admin/settings"
                  className="block px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700"
                >
                  <FaCog className="inline mr-2" size={14} />
                  Paramètres
                </Link>
                <button
                  onClick={handleLogout}
                  className="block w-full text-left px-4 py-2 text-sm text-red-600 dark:text-red-400 hover:bg-gray-100 dark:hover:bg-slate-700"
                >
                  <FaSignOutAlt className="inline mr-2" size={14} />
                  Déconnexion
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar;
